import { applyMiddleware, createStore } from "redux";
import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import thunk from "redux-thunk";

import rootReducer from "@redux/reducers";

// export default store;

const { REACT_APP_PRIVATE_SECRET_KEY } = process.env;

const encryptionConfig = {
  secretKey: REACT_APP_PRIVATE_SECRET_KEY,
  onError: (error) => {
    console.log("encryptionConfig error :>> ", error);
  },
};

export const PERSIST_CONFIG = {
  key: "root",
  storage,
  transforms: [encryptTransform(encryptionConfig)],
  blacklist: ["modalStatus", "loadingStatus"],
};

const persistedReducer = persistReducer(PERSIST_CONFIG, rootReducer);

// const store = createStore(persistedReducer, applyMiddleware(thunk, logger));
const store = createStore(persistedReducer, applyMiddleware(thunk));

const persistor = persistStore(store);

export { store, persistor };
